<template>
    <div>
        <div class="mb2">{{title}}</div>
        <div v-for="(array, index) in items" :key="index" @click="$emit('click', array)" >
            <div> {{index + 1}}. 
                <span class="yellow b grow pointer">{{array.item}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array
        },
        title: {
            type: String
        }
    },
    methods: {
        searchCategory(id) {
            this.$router.push({ path: '/search', query: { category: id } });
        }
    }
};
</script>
